export const usePdfUtils = () => {
  const openPdfInNewTab = (base64Pdf: string) => {
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };

  const downloadPdfFromBase64 = (
    rawBase64Pdf: string,
    fileName = 'document.pdf',
  ) => {
    try {
      const base64 = rawBase64Pdf
        .replace(/^data:application\/pdf;base64,/, '')
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(
          rawBase64Pdf.length + ((4 - (rawBase64Pdf.length % 4)) % 4),
          '=',
        );

      const byteCharacters = atob(base64);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      // Optional: Revoke the blob URL after download
      setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    } catch (err) {
      console.error('Failed to download PDF', err);
    }
  };
  return {
    openPdfInNewTab,
    downloadPdfFromBase64,
  };
};

export default usePdfUtils;
